import ResultsResearch from './resultsResearch.js';
export default ResultsResearch;
